import React from 'react';
import { Card, CardContent, Grid } from '@material-ui/core';

/**
 * Error message when New Admin is not activated
 */
const NotActivatedMessage = () => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
    style={{ minHeight: '100vh' }}
  >
    <Grid item xs={3}>
      <Card>
        <CardContent>
          <p>Welcome to Investment Café ICX Admin.</p>
          <p>
            We are configuring your access to the new Administration portal.
            Once this is completed you will be notified.
          </p>
          <p>
            In the meantime, please do not hesitate to contact your Account
            Manager if you would like any further information on the new
            Administration portal.
          </p>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
);

export default NotActivatedMessage;
